export const sizing = {
    drawerWidth: 235
}